import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ButtonModule } from "../button/index";
import { DialogBaseModule } from "./dialog.base.module";
import { FormModule } from "../form/index";
import { GenericModule } from "../generic/index";
import { IconModule } from "../icon/index";
import { LoadingModule } from "../loading/index";
import { MediaModule } from "../media/index";
import { SpinnerModule } from "../spinner/index";

import { DialogWrapperComponent } from "./components/wrapper/wrapper.component";

import { DialogHeaderComponent } from "./components/partials/header/header.component";
import {
  DialogTitleComponent,
  DialogHeadingTitleComponent
} from "./components/partials/title/title.component";
import {
  DialogSubtitleComponent,
  DialogHeadingSubtitleComponent
} from "./components/partials/subtitle/subtitle.component";
import {
  DialogCloseComponent,
  DialogCloseDirective
} from "./components/partials/close/close.component";
import {
  DialogDismissComponent,
  DialogDismissDirective
} from "./components/partials/dismiss/dismiss.component";
import { DialogContentComponent } from "./components/partials/content/content.component";
import { DialogBodyComponent } from "./components/partials/body/body.component";
import { DialogFooterComponent } from "./components/partials/footer/footer.component";

import { DialogService } from "./dialog.service";
import { DialogRef, DialogParams } from "./dialog.base";
import { DialogLoadingComponent } from "./components/loading/loading.component";
import { DialogAlertComponent } from "./components/alert/alert.component";
import { DialogConfirmComponent } from "./components/confirm/confirm.component";
import { DialogPromptComponent } from "./components/prompt/prompt.component";
import { DialogViewerComponent } from "./components/viewer/viewer.component";

export * from "./dialog.base.module";

export { DialogService } from "./dialog.service";
export { Dialog, DialogRef, DialogParams } from "./dialog.base";

export { DialogLoadingComponent } from "./components/loading/loading.component";
export { DialogAlertComponent } from "./components/alert/alert.component";
export { DialogConfirmComponent } from "./components/confirm/confirm.component";

@NgModule({
  declarations: [
    DialogLoadingComponent,
    DialogAlertComponent,
    DialogConfirmComponent,
    DialogPromptComponent,
    DialogViewerComponent
  ],
  entryComponents: [
    DialogLoadingComponent,
    DialogAlertComponent,
    DialogConfirmComponent,
    DialogPromptComponent,
    DialogViewerComponent
  ],
  imports: [
    CommonModule,

    DialogBaseModule,

    ButtonModule,
    FormModule,
    GenericModule,
    IconModule,
    LoadingModule,
    MediaModule,
    SpinnerModule
  ],
  exports: [
    DialogWrapperComponent,

    DialogHeaderComponent,
    DialogTitleComponent,
    DialogHeadingTitleComponent,
    DialogSubtitleComponent,
    DialogHeadingSubtitleComponent,
    DialogCloseComponent,
    DialogCloseDirective,
    DialogDismissComponent,
    DialogDismissDirective,
    DialogContentComponent,
    DialogBodyComponent,
    DialogFooterComponent
  ],
  providers: [DialogService, DialogRef, DialogParams]
})
export class DialogModule {}
